import { AxiosRequestConfig } from "axios";
import useAxios from "./useAxios";
import CustomError from "../util/customError";
import PagedResult from "../interfaces/pagedResult";

const useApi = <T>(endpoint: string) => {
    const axiosInstance = useAxios();

    const recover = () => {
        return axiosInstance.get<T>(endpoint)
            .then(res => res.data)
            .catch(error => {
                handleError(error)
            });
    };

    const getPage = (config: AxiosRequestConfig) => {
        return axiosInstance
            .get<PagedResult<T>>(endpoint + "/paged", config)
            .then(res => res.data)
            .catch(error => {
                handleError(error)
            });
    }

    const register = (data: T) => {
        return axiosInstance
            .post<T>(endpoint, data)
            .then(res => res.data)
            .catch(error => {
                handleError(error)
            });
    }

    const edit = (data: T) => {
        return axiosInstance
            .put<T>(endpoint, data)
            .then(res => res.data)
            .catch(error => {
                handleError(error)
            });
    }

    const removeById = (id: number) => {
        return axiosInstance
            .delete(endpoint + "/" + id)
            .then(res => res.data)
            .catch(error => {
                handleError(error);
            });
    }

    const handleError = (error: any) => {
        if(error.response) {
            throw new CustomError(error.response.data.message, error.response.data.errorCode);
        } else if (error.request) {
            throw new Error("No response received from the server.");
        } else {
            throw new Error("An unknown error occurred.");
        }
    }

    return { recover, getPage, register, edit, removeById };
}

export default useApi;